import { errorValidation } from './utils';

let vacancyPhone = $('#vacancy_phone');

/**
 * Init intlTelInput
 */
[vacancyPhone].forEach(phoneInput => {
	phoneInput
		.intlTelInput({
			initialCountry: 'md',
			placeholderNumberType: 'aggressive',
			utilsScript:
				'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js',
			separateDialCode: true,
			preferredCountries: ['md'],
			onlyCountries: ['ro', 'ua', 'md'],
		})
		.inputmask({
			mask: 'V9999999',
			definitions: {
				V: {
					validator: '^[1-9][0-9]*$',
				},
			},
		});

	// Set the initial country code on page load
	let initialCountryCode = phoneInput.intlTelInput(
		'getSelectedCountryData'
	).dialCode;
	let countryCodeInput = phoneInput
		.closest('.input-wrapper')
		.find('.country-code');
	countryCodeInput.val(initialCountryCode);

	// On blur: validate
	phoneInput.focusout(function () {
		if ($.trim(phoneInput.val())) {
			if (phoneInput.intlTelInput('isValidNumber')) {
				console.log('isValidNumber');
				// Save country code
				countryCodeInput.val(initialCountryCode);
			} else {
				phoneInput.addClass('_error');
			}
		}
	});

	// On keydown: reset
	phoneInput.keydown(function () {
		phoneInput.removeClass('_error');
	});
});

/**
 * Add custom validation method
 */
$.validator.addMethod(
	'validateVacancyPhonePhone',
	function (value, element) {
		return $(element).intlTelInput('isValidNumber');
	},
	window.translations.phoneInvalid
);
$.validator.addMethod(
	'validateFile',
	function (value, element) {
		var fileExtension = ['pdf', 'doc', 'docx'];
		return $.inArray(value.split('.').pop().toLowerCase(), fileExtension) != -1;
	},
	window.translations.invalidFileType
);

/**
 * Validate forms
 */
(() => {
	// One Click
	$("form[name='vacancy']").validate({
		ignore: [],
		...errorValidation,
		errorClass: 'form__error',
		rules: {
			'vacancy[name]': {
				required: true,
			},
			'vacancy[phone]': {
				required: true,
				validateVacancyPhonePhone: true,
			},
			'vacancy[email]': {
				required: true,
				email: true,
			},
			file: {
				required: true,
				validateFile: true,
			},
		},
		messages: {
			'vacancy[name]': {
				required: window.translations.required,
			},
			'vacancy[phone]': {
				required: window.translations.required,
			},
			'vacancy[email]': {
				required: window.translations.required,
				email: window.translations.emailInvalid,
			},
			file: {
				required: window.translations.required,
			},
		},
		submitHandler: form => {
			form.submit();
		},
		success: function (label) {
			let name = label.attr('for');
			label.text('');
		},
	});
})();
